/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuditEventType,
  AuditLogResponse,
  AuditScopeType,
} from '../models/index';
import {
    AuditEventTypeFromJSON,
    AuditEventTypeToJSON,
    AuditLogResponseFromJSON,
    AuditLogResponseToJSON,
    AuditScopeTypeFromJSON,
    AuditScopeTypeToJSON,
} from '../models/index';

export interface DownloadAuditLogCsvRequest {
    eventType?: AuditEventType | null;
    from?: Date | null;
    scopeId?: string | null;
    scopeType?: AuditScopeType | null;
    to?: Date | null;
}

export interface GetAuditLogRequest {
    eventType?: AuditEventType | null;
    from?: Date | null;
    limit?: number | null;
    offset?: number | null;
    scopeId?: string | null;
    scopeType?: AuditScopeType | null;
    to?: Date | null;
}

/**
 * AuditLogApi - interface
 * 
 * @export
 * @interface AuditLogApiInterface
 */
export interface AuditLogApiInterface {
    /**
     * Download audit log entries as CSV with optional filtering by time range, scope, and event type.
     * @summary Download audit log as CSV
     * @param {AuditEventType} [eventType] Filter by scope type
     * @param {Date} [from] Start time for the query (defaults to 90 days ago)
     * @param {string} [scopeId] Filter by scope ID
     * @param {AuditScopeType} [scopeType] Filter by scope type
     * @param {Date} [to] End time for the query (defaults to now)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogApiInterface
     */
    downloadAuditLogCsvRaw(requestParameters: DownloadAuditLogCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Download audit log entries as CSV with optional filtering by time range, scope, and event type.
     * Download audit log as CSV
     */
    downloadAuditLogCsv(requestParameters: DownloadAuditLogCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve audit log entries with optional filtering by time range, scope, and pagination.
     * @summary Get audit log entries
     * @param {AuditEventType} [eventType] Filter by scope type
     * @param {Date} [from] Start time for the query (defaults to 90 days ago)
     * @param {number} [limit] Maximum number of items to return (1-1000, default: 50)
     * @param {number} [offset] Number of items to skip (default: 0)
     * @param {string} [scopeId] Filter by scope ID
     * @param {AuditScopeType} [scopeType] Filter by scope type
     * @param {Date} [to] End time for the query (defaults to now)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogApiInterface
     */
    getAuditLogRaw(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogResponse>>;

    /**
     * Retrieve audit log entries with optional filtering by time range, scope, and pagination.
     * Get audit log entries
     */
    getAuditLog(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogResponse>;

}

/**
 * 
 */
export class AuditLogApi extends runtime.BaseAPI implements AuditLogApiInterface {

    /**
     * Download audit log entries as CSV with optional filtering by time range, scope, and event type.
     * Download audit log as CSV
     */
    async downloadAuditLogCsvRaw(requestParameters: DownloadAuditLogCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['eventType'] != null) {
            queryParameters['eventType'] = requestParameters['eventType'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['scopeId'] != null) {
            queryParameters['scopeId'] = requestParameters['scopeId'];
        }

        if (requestParameters['scopeType'] != null) {
            queryParameters['scopeType'] = requestParameters['scopeType'];
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/audit/download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download audit log entries as CSV with optional filtering by time range, scope, and event type.
     * Download audit log as CSV
     */
    async downloadAuditLogCsv(requestParameters: DownloadAuditLogCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadAuditLogCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve audit log entries with optional filtering by time range, scope, and pagination.
     * Get audit log entries
     */
    async getAuditLogRaw(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogResponse>> {
        const queryParameters: any = {};

        if (requestParameters['eventType'] != null) {
            queryParameters['eventType'] = requestParameters['eventType'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['scopeId'] != null) {
            queryParameters['scopeId'] = requestParameters['scopeId'];
        }

        if (requestParameters['scopeType'] != null) {
            queryParameters['scopeType'] = requestParameters['scopeType'];
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/audit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve audit log entries with optional filtering by time range, scope, and pagination.
     * Get audit log entries
     */
    async getAuditLog(requestParameters: GetAuditLogRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogResponse> {
        const response = await this.getAuditLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
